import { Component, Input } from '@angular/core';

export interface SettlementSummaryRow {
  label: string;
  value: number;
  /** Visual tone for the value: a positive/negative request delta, a plain muted row, or `send` —
   * a bold red "amount to actually send" (e.g. net to provider after withholding). */
  tone?: 'under' | 'over' | 'muted' | 'send';
}

/**
 * Shared settlement summary — a base amount, optional extra rows (e.g. a funding's under/over-request
 * delta), the two bank charges, and a bold net total. Used by AP Payment and Cash Funding with dynamic
 * labels. The parent computes `net` so the fee direction stays on each screen:
 *   - AP Payment (outgoing): net = base + fees  → `feesReduceNet = false`
 *   - Cash Funding (incoming): net = base − fees → `feesReduceNet = true`
 */
@Component({
  selector: 'app-settlement-summary',
  templateUrl: './settlement-summary.component.html',
  styleUrl: './settlement-summary.component.scss',
})
export class SettlementSummaryComponent {
  @Input() title = '';
  @Input() hint = '';

  @Input() baseLabel = '';
  @Input() baseAmount = 0;

  /** Optional rows shown between the base and the fees (e.g. "Under request"). */
  @Input() extraRows: SettlementSummaryRow[] = [];

  @Input() bankingFeeLabel = 'Banking fee';
  @Input() securityFeeLabel = 'Security fee';
  @Input() bankingFee = 0;
  @Input() securityFee = 0;
  /** Fees reduce the net (incoming) → show as "− x"; otherwise they add (outgoing) → "+ x". */
  @Input() feesReduceNet = true;

  @Input() netLabel = '';
  @Input() net = 0;

  @Input() currencyLabel = '';

  get feeSign(): string {
    return this.feesReduceNet ? '−' : '+';
  }
}
